import { ApiResponse, http } from '@config/api';

export interface Service {
	id: string;
	name: string;
	price?: number;
	unit?: string;
	children: {
		id: string;
		name: string;
		price: number;
		unit: string;
	}[];
}

export async function getAllServices(): Promise<Service[]> {
	const response = await http.get<ApiResponse<Service[]>>('business-services', 'list/');

	return response.data.data;
}

export async function getServiceById(ids: string[]): Promise<Service[]> {
	const response = await http.get<ApiResponse<Service[]>>(`business-services`, `list/get-by-id/`, {
		ids: ids.join(','),
	});

	return response.data.data;
}
